import useLDRingFeature from '../../hooks/useLDRingFeature';
import { useIsSingleSessionEvent } from '../../displayHelpers';

const useIsCommunityFeatureEnabled = (eventUniqueName: string) => {
    const isSSE = useIsSingleSessionEvent(eventUniqueName);
    const { data: isCommunityToggleEnabled, isLoading } = useLDRingFeature(
        eventUniqueName,
        'the-venue-community',
        'community'
    );
    return isLoading || isSSE ? false : isCommunityToggleEnabled;
};

export default useIsCommunityFeatureEnabled;
